import(/* webpackMode: "eager" */ "/var/www/uvercee-new/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"weight\":[\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/var/www/uvercee-new/node_modules/remixicon/fonts/remixicon.css");
;
import(/* webpackMode: "eager" */ "/var/www/uvercee-new/public/css/navbar.css");
;
import(/* webpackMode: "eager" */ "/var/www/uvercee-new/public/fonts/flaticon_mycollection.css");
;
import(/* webpackMode: "eager" */ "/var/www/uvercee-new/node_modules/swiper/swiper-bundle.css");
;
import(/* webpackMode: "eager" */ "/var/www/uvercee-new/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/uvercee-new/src/components/UverceeComponents/Layout/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/uvercee-new/src/components/UverceeComponents/PopUp/PopupClient.tsx");
